import ApiClient from './ApiClient';

class ProductsClient extends ApiClient {
  constructor(url) {
    super(url ? `${url}` : '');
  }

  async getProducts() {
    try {
      return await this.get('/products');
    } catch (error) {
      throw new Error(`Failed to get products`);
    }
  }

  async addProduct(formData) {
    try {
      return await this.post('/products', formData);
    } catch (error) {
      throw new Error(`Failed to add product`);
    }
  }

  async updateProduct(id, formData) {
    try {
      return await this.put(`/products/${id}`, formData);
    } catch (error) {
      throw new Error(`Failed to update product`);
    }
  }
}

export default ProductsClient;
